module.exports = __webpack_public_path__ + "static/media/arrow-right.9e693212.svg";